import { useSelector } from 'react-redux'
import { RootState, useAppDispatch, useAppSelector } from '../../redux/store'
import { fetchAssignedTaskDetails, updateAssignedTask } from '../../redux/task/actions'
import { selectUserTeamMemberInfo } from '../../redux/auth/selector'
import showToast from '../../Components/Common/SweetAlert/ToastAlert'

export const useUpdateAssignedTask = () => {
  const dispatch = useAppDispatch()

  const { loadingUpdateAssignedTask, errorUpdateAssignedTask } = useSelector(
    (state: RootState) => state.task,
  )

  const teamMemberDetails = useAppSelector(selectUserTeamMemberInfo)

  const teamMemberDetailsPayload = {
    teamMemberEmail: teamMemberDetails.email,
    teamMemberWorkdayId: teamMemberDetails.workdayId,
  }

  const updateTask = async (task: any) => {
    try {
      await dispatch(updateAssignedTask(task))
      showToast('success', 'Task status updated successfully!')
    } catch (err) {
      showToast('error', 'Error updating task status!')
    } finally {
      await dispatch(fetchAssignedTaskDetails(teamMemberDetailsPayload)).unwrap()
    }
  }

  return {
    loadingUpdateAssignedTask,
    errorUpdateAssignedTask,
    updateTask,
  }
}
